import { inject, Injectable, Signal, signal } from '@angular/core';
import { ReadonlyRepositoryCollectionService } from '@softline/core';
import { AbcAnalysisConfigurationsRepository } from '../repositories/abc-analysis-configurations.repository';
import {
  AbcAnalysisConfigurationRow,
  AbcAnalysisConfigurationsResult,
} from '../types/abc-analysis-configuration';

@Injectable()
export class AbcAnalysisConfigurationsService extends ReadonlyRepositoryCollectionService<
  AbcAnalysisConfigurationRow,
  AbcAnalysisConfigurationsResult,
  undefined
> {
  override readonly params: Signal<undefined> = signal(undefined);

  constructor() {
    super(inject(AbcAnalysisConfigurationsRepository));
  }

  protected override getAll(
    result: AbcAnalysisConfigurationsResult | null | undefined
  ): AbcAnalysisConfigurationRow[] {
    return result?.data ?? [];
  }

  protected override getId = (item: AbcAnalysisConfigurationRow): string =>
    String(item.abc_analysis_id);
}
